import React, { useState, useEffect } from 'react';
import { Save, Bot } from 'lucide-react';

export function SettingsTab({ settings, onSave, loading }) {
  const [formData, setFormData] = useState(settings || {});

  useEffect(() => {
    if (settings) setFormData(settings);
  }, [settings]);

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  if (!settings) {
    return <div className="text-center py-10 text-gray-400">Carregando...</div>;
  }

  return (
    <div className="space-y-6 max-w-2xl">
      {/* Personalização do Vendedor */}
      <div className="bg-gray-800/50 rounded-xl p-6 border border-gray-700/50">
        <h3 className="text-lg font-semibold text-white mb-4">Personalização do Vendedor</h3>
        <div className="space-y-4">
          <div>
            <label className="block text-sm text-gray-400 mb-1">Nome do Vendedor</label>
            <input
              type="text"
              value={formData.seller_name || ''}
              onChange={(e) => handleChange('seller_name', e.target.value)}
              className="w-full px-4 py-2 bg-gray-900 border border-gray-700 rounded-lg text-white"
              placeholder="Ex: João"
            />
          </div>
          <div>
            <label className="block text-sm text-gray-400 mb-1">Nome da Empresa</label>
            <input
              type="text"
              value={formData.company_name || ''}
              onChange={(e) => handleChange('company_name', e.target.value)}
              className="w-full px-4 py-2 bg-gray-900 border border-gray-700 rounded-lg text-white"
              placeholder="Ex: Pede é Fácil"
            />
          </div>
        </div>
      </div>

      {/* Detecção de Bot */}
      <div className="bg-gray-800/50 rounded-xl p-6 border border-gray-700/50">
        <h3 className="text-lg font-semibold text-white mb-4">Detecção de Bot</h3>
        <div className="space-y-4">
          <div>
            <label className="block text-sm text-gray-400 mb-1">
              Tempo limite para detectar bot (ms)
            </label>
            <input
              type="number"
              value={formData.bot_response_threshold_ms || 3000}
              onChange={(e) => handleChange('bot_response_threshold_ms', parseInt(e.target.value))}
              className="w-full px-4 py-2 bg-gray-900 border border-gray-700 rounded-lg text-white"
            />
            <p className="text-gray-500 text-xs mt-1">Respostas mais rápidas que isso serão consideradas de bot</p>
          </div>
          <div>
            <label className="block text-sm text-gray-400 mb-1">Palavras-chave de Bot</label>
            <textarea
              value={formData.bot_keywords?.join('\n') || ''}
              onChange={(e) => handleChange('bot_keywords', e.target.value.split('\n').filter(k => k.trim()))}
              className="w-full px-4 py-2 bg-gray-900 border border-gray-700 rounded-lg text-white h-32"
              placeholder="Uma palavra por linha..."
            />
          </div>
        </div>
      </div>

      {/* Limites */}
      <div className="bg-gray-800/50 rounded-xl p-6 border border-gray-700/50">
        <h3 className="text-lg font-semibold text-white mb-4">Limites</h3>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm text-gray-400 mb-1">Máximo de envios/dia</label>
            <input
              type="number"
              value={formData.max_daily_sends || 100}
              onChange={(e) => handleChange('max_daily_sends', parseInt(e.target.value))}
              className="w-full px-4 py-2 bg-gray-900 border border-gray-700 rounded-lg text-white"
            />
          </div>
          <div>
            <label className="block text-sm text-gray-400 mb-1">Tentativas por lead</label>
            <input
              type="number"
              value={formData.max_retries_per_lead || 3}
              onChange={(e) => handleChange('max_retries_per_lead', parseInt(e.target.value))}
              className="w-full px-4 py-2 bg-gray-900 border border-gray-700 rounded-lg text-white"
            />
          </div>
        </div>
      </div>

      <button
        onClick={() => onSave(formData)}
        disabled={loading}
        className="flex items-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 text-white rounded-lg transition-colors"
      >
        <Save size={18} />
        {loading ? 'Salvando...' : 'Salvar Configurações'}
      </button>
    </div>
  );
}

// ==================== MODAIS ====================
